'use client';

import { Button, ButtonProps } from '@mui/material';
import { recordEvent } from '@qb/frontend/analytics/ga4';
type ManufacturerTrackedLinkProps = Pick<ButtonProps, 'children' | 'size' | 'sx' | 'variant'> & {
  href: string;
  manufacturer: {
    id: number;
    name: string;
  };
  placement: string;
  trackingType: 'cta' | 'outbound' | 'resource';
};
export const ManufacturerTrackedLink = ({
  children,
  href,
  manufacturer,
  placement,
  trackingType,
  ...buttonProps
}: ManufacturerTrackedLinkProps) => {
  const isExternal = /^https?:\/\//.test(href);
  return <Button {...buttonProps} href={href} target={isExternal ? '_blank' : undefined} rel={isExternal ? 'noopener noreferrer' : undefined} onClick={() => {
    recordEvent(trackingType === 'outbound' ? 'manufacturer_outbound_click' : trackingType === 'resource' ? 'manufacturer_resource_click' : 'manufacturer_cta_click', {
      attributes: {
        manufacturer_id: manufacturer.id,
        manufacturer_name: manufacturer.name,
        placement,
        link_url: href,
        link_text: typeof children === 'string' ? children : undefined
      }
    });
  }} data-sentry-element="Button" data-sentry-component="ManufacturerTrackedLink" data-sentry-source-file="ManufacturerTrackedLink.tsx">
      {children}
    </Button>;
};